import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { QRCodeModule } from 'angularx-qrcode';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { RadioInputComponent } from './component/radio-input/radio-input';
import { HeaderComponent } from './component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';
import { SkuInventoryComponent } from './component/sku-inventory/sku-inventory.component';
import { AddonsComponent } from './component/addons/addons.component';
import { ImageViewComponent } from './component/image-view/image-view.component';
import { HeaderPopoverComponent } from './component/header-popover/header-popover.component';
import { ProfilePopoverComponent } from './component/profile-popover/profile-popover.component';
import { CartComponent } from './component/cart-icon/cart.component';
import { CheckoutButtonComponent } from './component/checkout-button/checkout-button.component';
import { ExpressBankingComponent } from './component/express-banking/express-banking.component';
import { ExpressBankingPayoutComponent } from './component/express-banking-payout/express-banking-payout.component';
import { AddImageComponent } from './component/add-image/add-image.component';
import { ImagePreviewComponent } from './component/image-preview/image-preview.component';
import { MediaLibraryComponent } from './component/media-library/media-library.component';
import { SlugCheckerComponent } from './component/slug-checker/slug-checker.component';
import { CoreModule } from '../core/core.module';
import { EntityCardComponent } from './component/entity-card/entity-card.component';
import { CBSInfoPanelComponent } from './component/cbs-info-panel/cbs-info-panel.component';
import { SurveyModal } from './modal/survey/survey.page';
import { DesktopOptimizedAlertComponent } from './component/desktop-optimized-alert/desktop-optimized-alert.component';
import { RaffleCardComponent } from './component/raffle-card/raffle-card.component';

@NgModule({
  declarations: [
    AddImageComponent,
    RadioInputComponent,
    EntityCardComponent,
    HeaderComponent,
    FooterComponent,
    SkuInventoryComponent,
    SlugCheckerComponent,
    AddonsComponent,
    ImageViewComponent,
    ImagePreviewComponent, // from CBS
    HeaderPopoverComponent,
    MediaLibraryComponent,
    ProfilePopoverComponent,
    CartComponent,
    CheckoutButtonComponent,
    ExpressBankingComponent,
    ExpressBankingPayoutComponent,
    CBSInfoPanelComponent,
    SurveyModal,
    DesktopOptimizedAlertComponent,
    RaffleCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QRCodeModule,
    CoreModule

  ],
  exports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QRCodeModule,
    AddImageComponent,
    RadioInputComponent,
    EntityCardComponent,
    HeaderComponent,
    FooterComponent,
    SkuInventoryComponent,
    AddonsComponent,
    ImageViewComponent,
    ImagePreviewComponent,
    HeaderPopoverComponent,
    MediaLibraryComponent,
    ProfilePopoverComponent,
    CartComponent,
    CheckoutButtonComponent,
    SlugCheckerComponent,
    ExpressBankingComponent,
    ExpressBankingPayoutComponent,
    CBSInfoPanelComponent,
    DesktopOptimizedAlertComponent,
    RaffleCardComponent
  ],
  providers: [
    InAppBrowser
  ]
})
export class SharedModule { }
